import { useState, useEffect, useRef } from "react";
import BannerStyle from "../assets/stylesheets/BannerSlider.module.css";

import Logger from "../utils/logger";

const log = Logger.create("BannerSlider");

const BannerSlider = ({ slides = [], delay = 5000, showControls = true }) => {
  const [index, setIndex] = useState(0);
  const timeoutRef = useRef(null);

  const resetTimeout = () => {
    if (timeoutRef.current) clearTimeout(timeoutRef.current);
  };

  useEffect(() => {
    if (!slides.length) return;

    resetTimeout();
    timeoutRef.current = setTimeout(
      () => setIndex((prevIndex) => (prevIndex + 1) % slides.length),
      delay
    );
    return () => resetTimeout();
  }, [index, slides, delay]);

  if (!slides.length) return null;

  const goToSlide = (slideIndex) => {
    setIndex(slideIndex);
  };

  return (
    <div className={BannerStyle["main-banner"]}>
      <div className={BannerStyle["banner-container"]}>
        <div
          className={BannerStyle["banner-slider"]}
          style={{ transform: `translateX(-${index * 100}%)` }}
        >
          {slides.map((slide, i) => (
            <div className={BannerStyle["banner-slide"]} key={i}>
              <img
                className={BannerStyle["banner-background"]}
                src={slide.image}
                alt={`banner-${i}`}
              />
              <div className={BannerStyle["banner-overlay"]}>
                <h1>{slide.title}</h1>
                <p>{slide.description}</p>
                {slide.buttonText && slide.link && (
                  <a href={slide.link} className={BannerStyle["banner-btn"]}>
                    {slide.buttonText}
                  </a>
                )}
              </div>
            </div>
          ))}
        </div>

        {/* Dots Navigation */}
        {showControls && slides.length > 1 && (
          <div className={BannerStyle["banner-dots"]}>
            {slides.map((_, slideIndex) => (
              <button
                key={slideIndex}
                className={`${BannerStyle["banner-dot"]} ${
                  slideIndex === index ? BannerStyle["banner-dot-active"] : ""
                }`}
                onClick={() => goToSlide(slideIndex)}
                aria-label={`Go to slide ${slideIndex + 1}`}
              />
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default BannerSlider;
